import { Component } from '@angular/core';
import { Router } from '@angular/router'; 
import { WebPageContent } from 'src/app/interfaces/WebContent/webPageContent';
import { GeneralService } from 'src/app/services/general.service';
import { WebContentService } from 'src/app/services/web-content.service';
import { TranslatorService } from 'src/app/services/translator.service';
import { WebPageContentForLanguage } from 'src/app/interfaces/WebContent/webPageContentForLanguage';


@Component({
    selector: 'app-veterans',
    templateUrl: './veterans.component.html',
    styleUrls: ['./veterans.component.scss'],
    standalone: false
})
export class VeteransComponent {
	loginGovUrl: string = '';
     loading: boolean = true;
	active = 1;
     webContent: WebPageContent | null = null;
     translatedWebContent: WebPageContentForLanguage | null = null;
     selectedLanguage: string = 'en';
     previewItemId?: string;
     previewParentItemId: string = '';

     constructor (public generalService: GeneralService, 
          public webContentService: WebContentService, 
          public translatorService: TranslatorService,
          private router: Router
     ) {
          let webContentPromise: any;
          var params = this.generalService.getQueryParameters(this.router.url);
          if (params && params['previewItemId']) {
               this.previewItemId = params['previewItemId']
               if (params && params['previewParentItemId']) {
                    this.previewParentItemId = params['previewParentItemId']
               }     
               webContentPromise = this.webContentService.getWebPageContentPreview('Veterans', this.previewItemId, this.previewParentItemId);
          } else {
               webContentPromise = this.webContentService.getWebPageContent('Veterans');
          }
          webContentPromise.subscribe((content: WebPageContent | null) => {
                    this.webContent = content;
                    if (this.webContent) {
                         if (this.translatorService.activeLanguage === 'en') {
                              this.translatedWebContent = this.webContent.englishContent;
                         } else if (this.translatorService.activeLanguage === 'es') {
                              this.translatedWebContent = this.webContent.spanishContent;
                         } else if (this.translatorService.activeLanguage === 'fr') {
                              this.translatedWebContent = this.webContent.frenchContent;
                         }
                    }

                    this.loading = false;
               });
          this.selectedLanguage = translatorService.activeLanguage;
     }

	ngOnInit(): void {
          this.routingHandler();
          setTimeout(() => this.scrollToTop(), 500);
	}

	routingHandler() {
		window.onbeforeunload = null;
	}

	scrollToTop() {
		window.scrollTo(0, 0);
	}

     async redirectToLoginGov() {
          this.loading = true;
          this.scrollToTop();
		let authCode = '';
		await this.generalService.getLoginGovUrl(authCode).toPromise().then((response: string) => {
			this.loginGovUrl = response;
		});
          
          setTimeout(() => this.loading = false, 2000);
          window.location.href = this.loginGovUrl;
	}

     getHeading() {
          if (this.selectedLanguage.toLocaleUpperCase() !== this.translatorService.getActiveLanguage().toLocaleUpperCase()) {
               this.selectedLanguage = this.translatorService.getActiveLanguage().toLocaleUpperCase();
               if (this.selectedLanguage === 'EN') {
                    this.translatedWebContent = this.webContent!.englishContent;
               } else if (this.selectedLanguage === 'ES') {
                    this.translatedWebContent = this.webContent!.spanishContent;
               } else {
                    this.translatedWebContent = this.webContent!.frenchContent;
               }

          }
          return this.translatedWebContent?.pageHeading;
     }
}
